const Paused = (props) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="currentColor">
        <rect height="13.5" rx="1.875" width="3.75" x="7" y="5" />
        <rect height="13.5" rx="1.875" width="3.75" x="13.1929" y="5" />
      </g>
    </svg>
  );
};
export default Paused;
